import type { OfflineManifest } from '@floorfile/contracts'
/** D24 owner manifest, consumed by the shared offline runtime. */
export const ncrOfflineManifest: OfflineManifest = {module:'ncr',entities:['ncr'],actions:['create','add-investigation-note','capture-disposition-draft'],conflictPolicy:'server-review-required',requiresOnline:['approve-disposition','release-hold','close','raise-car']}
